import { render, staticRenderFns } from "./TaxChargeSelector.vue?vue&type=template&id=6db4a5bb&scoped=true&"
import script from "./TaxChargeSelector.vue?vue&type=script&lang=js&"
export * from "./TaxChargeSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaxChargeSelector.vue?vue&type=style&index=0&id=6db4a5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4a5bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCol,VRow})
